import React from "react";
import { useNavigate } from "react-router-dom";

const ActionsButton = ({ formData, isActionsOpen, setIsActionsOpen, setIsInspectionsWizardOpen }) => {
  const navigate = useNavigate();

  // logic for actions menu
  const handleAddDevice = () => {
    navigate(
      `/setup/add-device?buildingId=${formData.buildingID}&buildingSite=${formData.addressLine1}&address=${formData.city}`
    );
  };

  const handleAccountCollections = () => {
    navigate(`/setup/account-collections/${formData.buildingID}`);
  };

  const NavigateMaintenanceContractWizard = () => {
    navigate(`/maintenance/maintenance-contract-entry`, {
      state: {
        buildingId: formData.buildingID,
        buildingSite: formData.addressLine1,
      },
    });
  };

  const NavigateProposalWizard = () => {
    navigate(`/setup/proposal-wizard`);
  };

  const NavigateInspectionWizard = () => {
    navigate(
      `/inspections-violations/inspections-wizard?buildingId=${formData.buildingID}&agencyId=${formData.agencyID}`
    );
  };

  const NavigateRecordViewer = () => {
    navigate("/setup/buildingrecords", {
      state: { user: "", buildingId: formData.buildingID },
    });
  };

  const NavigateBuildingLedger = () => {
    navigate(`/setup/view-building-ledger/${formData.buildingID}`);
  };
  return (
    <div className="relative inline-block">
      <button
        onClick={() => setIsActionsOpen((prev) => !prev)}
        className={`p-2 hover:bg-gray-200 transition ${
          isActionsOpen ? "bg-teal-100" : "bg-white"
        }`}
      >
        Actions
      </button>
      {isActionsOpen && (
        <div className="absolute right-0 w-56 bg-white border border-gray-300 shadow-lg z-50">
          <ul>
            <li
              className="px-4 py-2 hover:bg-teal-100 cursor-pointer"
              onClick={handleAddDevice}
            >
              Add a Device
            </li>
            <li
              className="px-4 py-2 hover:bg-teal-100 cursor-pointer"
              onClick={handleAccountCollections}
            >
              View Account Collections
            </li>
            <li
              className="px-4 py-2 hover:bg-teal-100 cursor-pointer"
              onClick={NavigateMaintenanceContractWizard}
            >
              Run the Add Maintenance Contract Wizard
            </li>
            <li
              className="px-4 py-2 hover:bg-teal-100 cursor-pointer"
              onClick={NavigateProposalWizard}
            >
              Run the Proposal Wizard
            </li>
            <li
              className="px-4 py-2 hover:bg-teal-100 cursor-pointer"
              onClick={() => setIsInspectionsWizardOpen(true)}
            >
              Run the Inspection Wizard
            </li>
            <li
              className="px-4 py-2 hover:bg-teal-100 cursor-pointer"
              onClick={NavigateRecordViewer}
            >
              View Building Records
            </li>
            <li
              className="px-4 py-2 hover:bg-teal-100 cursor-pointer"
              onClick={NavigateBuildingLedger}
            >
              View Building Ledger
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default ActionsButton;
